document.addEventListener('arlojscontrolsloaded', function () {
  var platformID = 'tpctraining.arlo.co';
  var catalogue = {
    moduleType: 'EventTemplateCatalogue',
    targetElement: '#event-template-catalogue',
    template: '#event-template-catalogue-template',
    includeLoadMoreButton: true,
    loadMoreButtonText: 'Show More',
    eventFilterControlId: 1,
    eventTemplateFilterControlId: 2,
    maxCount: 100,
    maxNextRunningEvents: 1, //Defaults to 1
    resultCountTarget: '#result-count',
    customUrls: {
      eventtemplate: '/public-seminars/',
      //venue: "/venue/",
      //presenter: "/presenter/"
    },
    callbacks: {
      onShow: catalogueOnShow,
    },
    filter: {
      // Category Codes from Arlo website settings
      code: filterCode,
    },
  };
  var app = new window.ArloWebControls();
  app.start({
    platformID: platformID,
    showDevErrors: true,
    modules: [catalogue],
  });
  function catalogueOnShow(getRenderCollectionElements, $) {
    var listItems = getRenderCollectionElements();
    var listParent = $(listItems[0]).parent()[0];
    ElementQueries.init();
    //Reset wrapper to static position
    $('.arlo-catalogue-wrapper').css('position', 'static');
  }
});
